import { DocumentChartBarIcon } from "@heroicons/react/24/outline";
import { ROUTES } from "./general";

export const SALES_BY_PRODUCT = 'sales-by-product';
export const SALES_BY_PRODUCT_BY_DAY = 'sales-by-product-by-day';
export const MONTHLY_AP_PO_PAID = 'monthly-ap-po-paid';
export const BILLCOM_PO_RECONCILIATION = 'billcom-po-reconciliation';
export const BILLCOM_AP_WRITEBACK_STATUS = 'billcom-ap-writeback-status';
export const BILLCOM_BANK_CASH_RECON = 'billcom-bank-cash-recon';
export const INBOUND_SHIPMENTS = 'inbound-shipments';
export const INBOUND_SHIPMENTS_OVERVIEW = 'inbound-shipments-overview';
export const MONTHLY_INBOUND_SHIPMENTS_VALUES = 'received-inventory-value';
export const RECEIVED_SHIPMENTS_REPORTS = 'received-shipments-reports';
export const WAREHOUSE_INVENTORY_VALUE = 'warehouse-inventory-value';
export const WAREHOUSE_RECONCILIATION = 'warehouse-reconciliation';
export const BIN_RESTOCKING_BRIEF = 'bin-restocking-brief';
export const PICK_PACK_REPORT = 'pick-pack-report';
export const INBOUND_GET_READY = 'inbound-get-ready';
export const INBOUND_RECEIVING_PUTAWAY = 'inbound-receiving-putaway';
export const RETURNS_PROCESSING = 'returns-processing';
export const SALES_REVENUE = 'sales-revenue';
export const SALES_REVENUE_MONTHLY = 'sales-revenue-monthly';
export const SHOPIFY_PROFIT_SUMMARY = 'shopify-profit-summary';
export const SHOPIFY_PROFIT_BY_SKU_SUMMARY = 'shopify-profit-by-sku-summary';
export const AMAZON_PROFIT_SUMMARY = 'amazon-profit-summary';
export const AMAZON_PROFIT_BY_SKU_SUMMARY = 'amazon-profit-by-sku-summary';
export const MONTHLY_PO_AP_DUE = 'monthly-po-ap-due';
export const MONTHLY_PO_AP_PROGRESS = 'monthly-po-ap-progress';
export const TOTAL_PRODUCT_REVENUE = 'total-product-revenue';
export const AMAZON_MONTH_END_CLOSE_SUMMARY = 'amazon-month-end-close-summary';
export const INVENTORY_COST_CHANGE = 'inventory-cost-change';
export const SHIPPING_EACH_COST_CHANGE = 'shipping-each-cost-change';
export const FEDEX_BILLING_RECONCILIATION = 'fedex-billing-reconciliation';
export const SHIPHERO_LABEL_COST = 'shiphero-label-cost';
export const PACKAGING_USAGE = 'packaging-usage';
export const QBO_CHANGE_LEDGER = 'qbo-change-ledger';
export const INVENTORY_LEDGER = 'inventory-ledger';
export const AMAZON_FBA_TRANSFER_LEDGER = 'amazon-fba-transfer-ledger';
export const AMAZON_FBA_TRANSFER_HISTORY = 'amazon-fba-transfer-history';
export const BILLCOM_PO_BALANCE_RECONCILIATION = 'billcom-po-balance-reconciliation';
export const PO_LEDGER_SHADOW = 'po-ledger-shadow';
export const MONTH_END_INVENTORY = 'month-end-inventory';
export const PO_STATUS_AUDIT = 'po-status-audit';
export const CLOSED_PO_RECONCILIATION = 'closed-po-reconciliation';
export const MISSING_INVENTORY_COST = 'missing-inventory-cost';
export const SOURCE_SKUS_BY_PRODUCT = 'source-skus-by-product';
export const MAX_DISCOUNT_PRICING = 'max-discount-pricing';
export const EADIN_COGS = 'eadin-cogs';
export const EADIN_CATALOG = 'eadin-catalog';
export const EADIN_INVENTORY = 'eadin-inventory';
export const BOM_PACKAGING = 'bom-packaging';
export const LOW_STOCK_ALERTS = 'low-stock-alerts';
export const AMAZON_FBA_LOW_STOCK_ALERTS = 'amazon-fba-low-stock-alerts';
export const LOW_STOCK_SOLD_OUT_ALERTS = 'low-stock-sold-out-alerts';
export const RECENT_POS = 'recent-pos';
export const META_INSIGHTS = 'meta-insights';
export const META_ADS = 'meta-ads';
export const DATA_RECONCILIATION = 'data-reconciliation';
export const KLAVIYO_CAMPAIGNS = 'klaviyo_campaigns';
export const KLAVIYO_CAMPAIGN_PERFORMANCE = 'klaviyo_campaign_performance';
export const KLAVIYO_FLOWS = 'klaviyo_flows';
export const KLAVIYO_FLOW_PERFORMANCE = 'klaviyo_flow_performance';
export const KLAVIYO_LISTS = 'klaviyo_lists';
export const KLAVIYO_SEGMENTS = 'klaviyo_segments';
export const KLAVIYO_METRICS = 'klaviyo_metrics';
export const KLAVIYO_METRIC_AGGREGATES = 'klaviyo_metric_aggregates';
export const DEMAND_PLANNING_CHANGE_LOG = 'demand-planning-change-log';
export const DAILY_CHANNEL_METRICS = 'daily-channel-metrics';
export const DAILY_SUMMARY = 'daily-summary';
export const AMAZON_IMPORTS = 'amazon-imports';
export const AMAZON_TRANSACTION_DETAIL = 'amazon-transaction-detail';
export const AMAZON_PL_SUMMARY = 'amazon-pl-summary';
export const AMAZON_AD_SPEND_DETAIL = 'amazon-ad-spend-detail';
export const AMAZON_RECONCILIATION_EXCEPTIONS = 'amazon-reconciliation-exceptions';
export const SKU_ALLOCATION_CHANGE_LOG = 'sku-allocation-change-log';
// Available reports configuration
// Please do not change already existing ids ( this is needed for our reports edit mode)
export const availableReports = [
    {
      id: QBO_CHANGE_LEDGER,
      name: 'QBO Change Ledger',
      description: 'QuickBooks transactions changed after month close, by account, with before/after and net income impact',
      path: ROUTES.REPORTS_QBO_CHANGE_LEDGER,
      icon: <DocumentChartBarIcon className="h-5 w-5" />
    },
    {
      id: AMAZON_FBA_TRANSFER_LEDGER,
      name: 'Amazon FBA Transfer Ledger',
      description: 'Inventory that left ShipHero for Amazon FBA: in-transit and received units, landed-cost value, Amazon shipment IDs, variances and QBO status',
      category: 'finance',
      path: ROUTES.REPORTS_AMAZON_FBA_TRANSFER_LEDGER,
      icon: <DocumentChartBarIcon className="h-5 w-5" />
    },
    {
      id: MONTH_END_INVENTORY,
      name: 'Month-End Inventory',
      description: 'Beginning and ending sellable inventory units and value by month for Vegas and Amazon FBA, with SKU detail and QuickBooks variance',
      category: 'finance',
      path: ROUTES.REPORTS_MONTH_END_INVENTORY,
      icon: <DocumentChartBarIcon className="h-5 w-5" />
    },
    {
      id: INVENTORY_LEDGER,
      name: 'Inventory Ledger',
      description: 'Every ShipHero inventory change (transfers, adds/removes, cycle counts, receiving) with who did it and before/after quantities',
      path: ROUTES.REPORTS_INVENTORY_LEDGER,
      icon: <DocumentChartBarIcon className="h-5 w-5" />
    },
    {
      id: FEDEX_BILLING_RECONCILIATION,
      name: 'FedEx Billing Reconciliation',
      description: 'Compare FedEx invoice billing with ShipHero label costs',
      path: ROUTES.REPORTS_FEDEX_BILLING_RECONCILIATION,
      icon: <DocumentChartBarIcon className="h-5 w-5" />
    },
    {
      id: SHIPHERO_LABEL_COST,
      name: 'ShipHero Label Cost (Monthly)',
      description: 'Month-end label cost: one priced label per order shipped in the month, by carrier',
      path: ROUTES.REPORTS_SHIPHERO_LABEL_COST,
      icon: <DocumentChartBarIcon className="h-5 w-5" />
    },
    {
      id: PACKAGING_USAGE,
      name: 'Packaging Usage (Monthly)',
      description: 'Month-end boxes used by ShipHero box name, mapped to packaging SKU and weighted cost',
      path: ROUTES.REPORTS_PACKAGING_USAGE,
      icon: <DocumentChartBarIcon className="h-5 w-5" />
    },
    {
      id: AMAZON_IMPORTS,
      name: 'Amazon CSV Imports',
      description: 'Import Amazon transaction detail and campaign-level ad spend CSV files',
      path: ROUTES.REPORTS_AMAZON_IMPORTS,
      icon: <DocumentChartBarIcon className="h-5 w-5" />
    },
    {
      id: AMAZON_TRANSACTION_DETAIL,
      name: 'Amazon Transaction Detail',
      description: 'Amazon transaction detail with signed revenue, taxes, fees, and net total',
      path: ROUTES.REPORTS_AMAZON_TRANSACTION_DETAIL,
      icon: <DocumentChartBarIcon className="h-5 w-5" />
    },
    {
      id: AMAZON_RECONCILIATION_EXCEPTIONS,
      name: 'Amazon Reconciliation Exceptions',
      description: 'Review and approve dates proposed from Amazon Unified Transaction CSVs',
      path: ROUTES.REPORTS_AMAZON_RECONCILIATION_EXCEPTIONS,
      icon: <DocumentChartBarIcon className="h-5 w-5" />
    },
    {
      id: AMAZON_PL_SUMMARY,
      name: 'Amazon P&L Summary',
      description: 'Monthly Amazon P&L rollup by GL account with YTD and % of sales',
      path: ROUTES.REPORTS_AMAZON_PL_SUMMARY,
      icon: <DocumentChartBarIcon className="h-5 w-5" />
    },
    {
      id: AMAZON_AD_SPEND_DETAIL,
      name: 'Amazon Ad Spend Detail',
      description: 'Amazon advertising detail with campaign, SKU, spend, sales, and conversion metrics',
      path: ROUTES.REPORTS_AMAZON_AD_SPEND_DETAIL,
      icon: <DocumentChartBarIcon className="h-5 w-5" />
    },
    {
      id: SALES_BY_PRODUCT,
      name: 'Sales by Product by Month',
      description: 'Monthly sales analysis by product group including quantity sold and gross sales',
      path: ROUTES.REPORTS_SALES_BY_PRODUCT,
      icon: <DocumentChartBarIcon className="h-5 w-5" />
    },
    {
      id: MONTHLY_INBOUND_SHIPMENTS_VALUES,
      name: 'Received Inventory Value',
        description: 'Received inventory valuation by Purchase Order, using preserved receipt values and adjustments',
      path: ROUTES.REPORTS_MONTHLY_INBOUND_SHIPMENTS_VALUES,
      icon: <DocumentChartBarIcon className="h-5 w-5" />
    },
    {
      id: RECEIVED_SHIPMENTS_REPORTS,
      name: 'Recieved Shipments Reports',
      description: 'Inbound receiving status by Purchase Order (estimated delivery, shipped vs received, missing units/value). Filtered by day 1 of receiving.',
      path: ROUTES.REPORTS_RECEIVED_SHIPMENTS_REPORTS,
      icon: <DocumentChartBarIcon className="h-5 w-5" />
    },
    {
      id: WAREHOUSE_INVENTORY_VALUE,
      name: 'Warehouse Inventory Value',
      description: 'Warehouse inventory value by PO (received/ordered/missing units + landed cost + Las Vegas/China value). Filtered by day 1 of receiving.',
      path: ROUTES.REPORTS_WAREHOUSE_INVENTORY_VALUE,
      icon: <DocumentChartBarIcon className="h-5 w-5" />
    },
    {
      id: WAREHOUSE_RECONCILIATION,
      name: 'Warehouse Location Reconciliation',
      description: 'Tie out ShipHero locations and inventory against the Location Master, 3D twin and capacity profiles',
      path: ROUTES.REPORTS_WAREHOUSE_RECONCILIATION,
      icon: <DocumentChartBarIcon className="h-5 w-5" />
    },
    {
      id: BIN_RESTOCKING_BRIEF,
      name: 'Bin Restocking Brief',
      description: 'Pickable replenishment brief — required, efficiency and insufficient-reserve restocks by bin, with the same PDF the daily Slack brief sends',
      path: ROUTES.REPORTS_BIN_RESTOCKING,
      icon: <DocumentChartBarIcon className="h-5 w-5" />
    },
    {
      id: PICK_PACK_REPORT,
      name: 'Pick & Pack Report',
      description: 'Every picker and packer by day from ShipHero pick and pack scans, with date-range trends and the same PDF the 4:30 PM Slack report sends',
      path: ROUTES.REPORTS_PICK_PACK,
      icon: <DocumentChartBarIcon className="h-5 w-5" />
    },
    {
      id: INBOUND_GET_READY,
      name: 'Inbound — Get Ready',
      description: 'Put-away plan for shipped inbound POs — where each SKU goes when it lands, with the same PDF the inbound Slack digest sends',
      path: ROUTES.REPORTS_INBOUND_GET_READY,
      icon: <DocumentChartBarIcon className="h-5 w-5" />
    },
    {
      id: INBOUND_RECEIVING_PUTAWAY,
      name: 'Inbound Receiving & Put-away',
      description: 'Receiving and put-away service levels with an evidence-based cleanup list',
      category: 'fulfillment',
      path: ROUTES.REPORTS_INBOUND_RECEIVING_PUTAWAY,
      icon: <DocumentChartBarIcon className="h-5 w-5" />
    },
    {
      id: RETURNS_PROCESSING,
      name: 'Returns Processing',
      description: 'Returns received, due, and processed in Shopify',
      category: 'fulfillment',
      path: ROUTES.REPORTS_RETURNS_PROCESSING,
      icon: <DocumentChartBarIcon className="h-5 w-5" />
    },
    {
      id: SALES_BY_PRODUCT_BY_DAY,
      name: 'Sales by Product by Day',
      description: 'Daily sales analysis by product group including quantity sold and gross sales',
      path: ROUTES.REPORTS_SALES_BY_PRODUCT_BY_DAY,
      icon: <DocumentChartBarIcon className="h-5 w-5" />
    },
    {
      id: MONTHLY_AP_PO_PAID,
      name: 'Monthly AP PO Paid',
      description: 'Payment details by Purchase Order including deposits, balance, credits, and shipping payments from the accounts payable system',
      path: ROUTES.REPORTS_PAYMENT,
      icon: <DocumentChartBarIcon className="h-5 w-5" />
    },
    {
      id: BILLCOM_PO_RECONCILIATION,
      name: 'Bill.com PO Reconciliation',
      description: 'Reconcile Bill.com payments against Eadin PO payment records',
      path: ROUTES.REPORTS_BILLCOM_PO_RECONCILIATION,
      icon: <DocumentChartBarIcon className="h-5 w-5" />
    },
    {
      id: BILLCOM_PO_BALANCE_RECONCILIATION,
      name: 'Bill.com PO Balance Reconciliation',
      description: 'Tie out Eadin PO balances due against Bill.com bill balances, per PO',
      path: ROUTES.REPORTS_BILLCOM_PO_BALANCE_RECONCILIATION,
      icon: <DocumentChartBarIcon className="h-5 w-5" />
    },
    {
      id: PO_LEDGER_SHADOW,
      name: 'PO Ledger (Shadow)',
      description: 'Compare the canonical PO liability projection with existing AP reports and review reconciliation exceptions',
      path: ROUTES.REPORTS_PO_LEDGER_SHADOW,
      icon: <DocumentChartBarIcon className="h-5 w-5" />
    },
    {
      id: PO_STATUS_AUDIT,
      name: 'PO Status Audit',
      description: 'Read-only review of persisted PO statuses against receiving, liability, and Bill.com evidence',
      path: ROUTES.REPORTS_PO_STATUS_AUDIT,
      icon: <DocumentChartBarIcon className="h-5 w-5" />
    },
    {
      id: CLOSED_PO_RECONCILIATION,
      name: 'Closed PO Reconciliation',
      description: 'Review closed POs that are not reconciled',
      path: ROUTES.REPORTS_CLOSED_PO_RECONCILIATION,
      icon: <DocumentChartBarIcon className="h-5 w-5" />
    },
    {
      id: BILLCOM_AP_WRITEBACK_STATUS,
      name: 'Bill.com AP Writeback Status',
      description: 'Review the Bill.com AP writeback pipeline and independent ledger verification',
      path: ROUTES.REPORTS_BILLCOM_AP_WRITEBACK_STATUS,
      icon: <DocumentChartBarIcon className="h-5 w-5" />
    },
    {
      id: BILLCOM_BANK_CASH_RECON,
      name: 'Bill.com vs Bank Cash Reconciliation',
      description: 'Compare Bill.com payments with settled bank cash by day',
      path: ROUTES.REPORTS_BILLCOM_BANK_CASH_RECON,
      icon: <DocumentChartBarIcon className="h-5 w-5" />
    },
    {
      id: INBOUND_SHIPMENTS,
      name: 'Inbound Shipments Report',
      description: 'Inbound shipment boxes grouped by PO with ship/receive dates and method',
      path: ROUTES.REPORTS_INBOUND_SHIPMENTS,
      icon: <DocumentChartBarIcon className="h-5 w-5" />
    },
    {
      id: INBOUND_SHIPMENTS_OVERVIEW,
      name: 'Inbound Shipments',
      description: 'Inbound purchase orders with status, estimated delivery, past-due days and received vs shipped quantities (mirrors the Shipping page).',
      path: ROUTES.REPORTS_INBOUND_SHIPMENTS_OVERVIEW,
      icon: <DocumentChartBarIcon className="h-5 w-5" />
    },
    {
      id: SALES_REVENUE,
      name: 'Product Sales By Month',
      description: 'Sales revenue analysis by product across Shopify and Amazon channels',
      path: ROUTES.REPORTS_SALES_REVENUE,
      icon: <DocumentChartBarIcon className="h-5 w-5" />
    },
    {
      id: SALES_REVENUE_MONTHLY,
      name: 'Total Product % of Revenue Summary',
      description: 'Percentage share of total monthly revenue for each active product',
      path: ROUTES.REPORTS_SALES_REVENUE_MONTHLY,
      icon: <DocumentChartBarIcon className="h-5 w-5" />
    },
    {
      id: SHOPIFY_PROFIT_SUMMARY,
      name: 'Shopify Profit By Product Summary',
      description: 'Profit metrics by product group for Shopify orders',
      path: ROUTES.REPORTS_SHOPIFY_PROFIT_SUMMARY,
      icon: <DocumentChartBarIcon className="h-5 w-5" />
    },
    {
      id: SHOPIFY_PROFIT_BY_SKU_SUMMARY,
      name: 'Shopify Profit By SKU Summary',
      description: 'Profit metrics by SKU for Shopify orders',
      path: ROUTES.REPORTS_SHOPIFY_PROFIT_BY_SKU_SUMMARY,
      icon: <DocumentChartBarIcon className="h-5 w-5" />
    },
    {
      id: AMAZON_PROFIT_SUMMARY,
      name: 'Amazon Profit By Product',
      description: 'Profit metrics by Product Catalog group for Amazon posted dates',
      category: 'Finance',
      path: ROUTES.REPORTS_AMAZON_PROFIT_SUMMARY,
      icon: <DocumentChartBarIcon className="h-5 w-5" />
    },
    {
      id: AMAZON_PROFIT_BY_SKU_SUMMARY,
      name: 'Amazon Profit By SKU',
      description: 'Profit metrics by Amazon seller SKU for posted dates',
      category: 'Finance',
      path: ROUTES.REPORTS_AMAZON_PROFIT_BY_SKU_SUMMARY,
      icon: <DocumentChartBarIcon className="h-5 w-5" />
    },
    {
      id: MONTHLY_PO_AP_DUE,
      name: 'Monthly PO AP Due',
      description: 'Payment schedule by Purchase Order including deposits, balance, credits, and shipping payments',
      category: 'finance',
      path: ROUTES.REPORTS_MONTHLY_PO_AP_DUE,
      icon: <DocumentChartBarIcon className="h-5 w-5" />
    },
    {
      id: MONTHLY_PO_AP_PROGRESS,
      name: 'Monthly PO AP Progress',
      description: 'Paid progress by Purchase Order with PO Date; includes paid deposits, balance, credits, shipping, total paid and unpaid',
      category: 'finance',
      path: ROUTES.REPORTS_MONTHLY_PO_AP_PROGRESS,
      icon: <DocumentChartBarIcon className="h-5 w-5" />
    },
    {
      id: TOTAL_PRODUCT_REVENUE,
      name: 'Total Product % of Revenue Detail',
      description: 'Detailed analysis of product revenue including order counts, sales figures, and revenue distribution across Shopify and Amazon channels',
      path: ROUTES.REPORTS_TOTAL_PRODUCT_REVENUE,
      icon: <DocumentChartBarIcon className="h-5 w-5" />
    },
    {
      id: AMAZON_MONTH_END_CLOSE_SUMMARY,
      name: 'Amazon Month End Close Summary',
      description: 'Summarized Amazon FBA financial metrics for the selected period',
      path: ROUTES.REPORTS_AMAZON_MONTH_END_CLOSE_SUMMARY,
      icon: <DocumentChartBarIcon className="h-5 w-5" />
    },
    {
      id: INVENTORY_COST_CHANGE,
      name: 'Inventory Cost Change',
      description: 'Cost history changes for Landed Cost / Weighted Cost by SKU and PO',
      path: ROUTES.REPORTS_INVENTORY_COST_CHANGE,
      icon: <DocumentChartBarIcon className="h-5 w-5" />
    },
    {
      id: DAILY_CHANNEL_METRICS,
      name: 'Daily Channel Metrics',
      description: 'Daily revenue and ad numbers per sales channel (Shopify, Amazon) in America/Denver days, with Triple Whale values alongside as an accuracy cross-check',
      path: ROUTES.REPORTS_DAILY_CHANNEL_METRICS,
      icon: <DocumentChartBarIcon className="h-5 w-5" />
    },
    {
      id: DAILY_SUMMARY,
      name: 'Daily Summary',
      description: 'One row per day (America/Denver): blended total revenue, orders, ad spend and MER, with Shopify and Amazon columns side by side — KPI-tracker style',
      path: ROUTES.REPORTS_DAILY_SUMMARY,
      icon: <DocumentChartBarIcon className="h-5 w-5" />
    },
    {
      id: DEMAND_PLANNING_CHANGE_LOG,
      name: 'Demand Planning Change Log',
      description: 'Every demand-planning edit (overrides, approvals, notes, exclusions, plan settings) with who changed it, when, and the old \u2192 new values',
      path: ROUTES.REPORTS_DEMAND_PLANNING_CHANGE_LOG,
      icon: <DocumentChartBarIcon className="h-5 w-5" />
    },
    {
      id: SKU_ALLOCATION_CHANGE_LOG,
      name: 'SKU Allocation Change Log',
      description: 'Every SKU Allocation input change (Override %, New Product Override %, approvals) with who changed it, when, the old \u2192 new values, the change source, and batch grouping',
      path: ROUTES.REPORTS_SKU_ALLOCATION_CHANGE_LOG,
      icon: <DocumentChartBarIcon className="h-5 w-5" />
    },
    {
      id: SHIPPING_EACH_COST_CHANGE,
      name: 'Shipping Each Cost Change',
      description: 'Cost history changes for Shipping Each by SKU and PO',
      path: ROUTES.REPORTS_SHIPPING_EACH_COST_CHANGE,
      icon: <DocumentChartBarIcon className="h-5 w-5" />
    },
    {
      id: MISSING_INVENTORY_COST,
      name: 'Missing Inventory Cost',
      description: 'Missing inventory cost report showing Landed Cost and Weighted Cost for all products',
      path: ROUTES.REPORTS_MISSING_INVENTORY_COST,
      icon: <DocumentChartBarIcon className="h-5 w-5" />
    },
    {
      id: SOURCE_SKUS_BY_PRODUCT,
      name: 'Source SKUs by Product',
      description: 'Report showing source SKUs by product for all products with eden_status ACTIVE',
      path: ROUTES.REPORTS_SOURCE_SKUS_BY_PRODUCT,
      icon: <DocumentChartBarIcon className="h-5 w-5" />
    },
    {
      id: MAX_DISCOUNT_PRICING,
      name: 'Max Discount Pricing',
      description: 'Max discount % and promo price by execution SKU, driven by demand tier discount drivers and Protected status',
      path: ROUTES.REPORTS_MAX_DISCOUNT_PRICING,
      icon: <DocumentChartBarIcon className="h-5 w-5" />
    },
    {
      id: EADIN_COGS,
      name: 'Eadin COGS',
      description: 'COGS report showing product cost information for items with cost changes',
      path: ROUTES.REPORTS_EADIN_COGS,
      icon: <DocumentChartBarIcon className="h-5 w-5" />
    },
    {
      id: EADIN_CATALOG,
      name: 'Eadin Catalog',
      description: 'Product catalog report with costs, inventory levels, and product details',
      path: ROUTES.REPORTS_EADIN_CATALOG,
      icon: <DocumentChartBarIcon className="h-5 w-5" />
    },
    {
      id: EADIN_INVENTORY,
      name: 'Eadin Inventory',
      description: 'Daily snapshot report of on-hand and on-order inventory by SKU',
      path: ROUTES.REPORTS_EADIN_INVENTORY,
      icon: <DocumentChartBarIcon className="h-5 w-5" />
    },
    {
      id: BOM_PACKAGING,
      name: 'BOM Packaging',
      description: 'Bill of Materials report showing product and packaging components',
      path: ROUTES.REPORTS_BOM_PACKAGING,
      icon: <DocumentChartBarIcon className="h-5 w-5" />
    },
    {
      id: LOW_STOCK_ALERTS,
      name: 'Low Stock Alerts',
      description: 'Report showing products with low stock levels',
      path: ROUTES.REPORTS_LOW_STOCK_ALERTS,
      icon: <DocumentChartBarIcon className="h-5 w-5" />,
    },
    {
      id: AMAZON_FBA_LOW_STOCK_ALERTS,
      name: 'Amazon FBA Low Stock Alerts',
      description: 'Amazon FBA SKUs whose Amazon stock covers fewer days than lead time plus safety',
      path: ROUTES.REPORTS_AMAZON_FBA_LOW_STOCK_ALERTS,
      icon: <DocumentChartBarIcon className="h-5 w-5" />,
    },
    {
      id: RECENT_POS,
      name: 'Recent PO Unit Costs',
      description: 'Most recent and previous PO unit costs by SKU (OPEN and CLOSED)',
      path: ROUTES.REPORTS_RECENT_POS,
      icon: <DocumentChartBarIcon className="h-5 w-5" />,
    },
    {
      id: META_INSIGHTS,
      name: 'Meta Insights',
      description: 'Daily Meta ad insights by account, campaign, ad set, and ad',
      path: ROUTES.REPORTS_META_INSIGHTS,
      icon: <DocumentChartBarIcon className="h-5 w-5" />,
    },
    {
      id: META_ADS,
      name: 'Meta Ads',
      description: 'Latest synced Meta ad metadata by account, campaign, and ad set',
      path: ROUTES.REPORTS_META_ADS,
      icon: <DocumentChartBarIcon className="h-5 w-5" />,
    },
    {
      id: KLAVIYO_CAMPAIGNS,
      name: 'Klaviyo Campaigns',
      description: 'Campaigns data from Klaviyo.',
      category: 'Marketing',
      path: ROUTES.REPORTS_KLAVIYO_CAMPAIGNS,
      icon: <DocumentChartBarIcon className="h-5 w-5" />,
    },
    {
      id: KLAVIYO_CAMPAIGN_PERFORMANCE,
      name: 'Klaviyo Campaign Performance',
      description: 'Campaign performance data from Klaviyo.',
      category: 'Marketing',
      path: ROUTES.REPORTS_KLAVIYO_CAMPAIGN_PERFORMANCE,
      icon: <DocumentChartBarIcon className="h-5 w-5" />,
    },
    {
      id: KLAVIYO_FLOWS,
      name: 'Klaviyo Flows',
      description: 'Flows data from Klaviyo.',
      category: 'Marketing',
      path: ROUTES.REPORTS_KLAVIYO_FLOWS,
      icon: <DocumentChartBarIcon className="h-5 w-5" />,
    },
    {
      id: KLAVIYO_FLOW_PERFORMANCE,
      name: 'Klaviyo Flow Performance',
      description: 'Flow performance data from Klaviyo.',
      category: 'Marketing',
      path: ROUTES.REPORTS_KLAVIYO_FLOW_PERFORMANCE,
      icon: <DocumentChartBarIcon className="h-5 w-5" />,
    },
    {
      id: KLAVIYO_LISTS,
      name: 'Klaviyo Lists',
      description: 'Lists data from Klaviyo.',
      category: 'Marketing',
      path: ROUTES.REPORTS_KLAVIYO_LISTS,
      icon: <DocumentChartBarIcon className="h-5 w-5" />,
    },
    {
      id: KLAVIYO_SEGMENTS,
      name: 'Klaviyo Segments',
      description: 'Segments data from Klaviyo.',
      category: 'Marketing',
      path: ROUTES.REPORTS_KLAVIYO_SEGMENTS,
      icon: <DocumentChartBarIcon className="h-5 w-5" />,
    },
    {
      id: KLAVIYO_METRICS,
      name: 'Klaviyo Metrics',
      description: 'Metrics data from Klaviyo.',
      category: 'Marketing',
      path: ROUTES.REPORTS_KLAVIYO_METRICS,
      icon: <DocumentChartBarIcon className="h-5 w-5" />,
    },
    {
      id: KLAVIYO_METRIC_AGGREGATES,
      name: 'Klaviyo Metric Aggregates',
      description: 'Metric aggregates data from Klaviyo.',
      category: 'Marketing',
      path: ROUTES.REPORTS_KLAVIYO_METRIC_AGGREGATES,
      icon: <DocumentChartBarIcon className="h-5 w-5" />,
    },
    // {
    //   id: LOW_STOCK_SOLD_OUT_ALERTS,
    //   name: 'Low Stock Sold Out Alerts',
    //   description: 'Report showing products with low stock levels that are sold out',
    //   path: ROUTES.REPORTS_LOW_STOCK_SOLD_OUT_ALERTS,
    //   icon: <DocumentChartBarIcon className="h-5 w-5" />,
    // },
];